import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';

import { ApprovalSignatureCredentials, ApprovalActionTypeEnum, AprovalCfr11PinStatusCodeEnum } from "@core/models/digital-signature.model";
/**
 * Specific component for approval cfr11 signature with pass and pin parameters
 */
@Component({
    selector: 'core-layout-modal-cfr11-digital-signature',
    templateUrl: './modal-cfr11-digital-signature.component.html',
    styleUrls: ['./modal-cfr11-digital-signature.component.scss']
})
export class LayoutModalCfr11DigitalSignatureComponent implements OnInit, OnDestroy {
    public readonly SIGNATURE_TYPES_ENUM = ApprovalActionTypeEnum;

    public readonly PIN_STATUS = AprovalCfr11PinStatusCodeEnum;

    public readonly SIGANTURE_STEP_ONE: number = 1;
    public readonly SIGANTURE_STEP_TWO: number = 2;

    @Input() type: string; // not used: just in case of more icons in the future (error,done,warning)
    @Input() label: string = '';
    @Input() signatureType: ApprovalActionTypeEnum;
    @Input() required: boolean = true;
    @Input() disabled: boolean = false; // white button
    @Input() pinRequestStatus: AprovalCfr11PinStatusCodeEnum; // variable for sent pin request status;

    @Output() mainAction = new EventEmitter<ApprovalSignatureCredentials>();
    @Output() secondAction = new EventEmitter<boolean>(); // LEFT GREY BUTTON
    @Output() pinRequestAction = new EventEmitter(); // request new pin 
    
    // template variables
    public form: FormGroup;
    public emailForm: FormGroup;
    public title: string;
    public placeholder: string = "Introduce your password"; 
    public emailPlaceholder: string = "Introduce your email"; 
    public secondButtonText: string = "Go back"; //LEFT GREY BUTTON

    public step: number = this.SIGANTURE_STEP_ONE;
    public input: string = ''; // input value

    public pinInputs: Array<string> = ["", "", "", "", "", ""];
    private pin: string = "";
    public validPin: boolean = false;
    public validEmail: boolean = false;

    private pinRequested: boolean = false;

    constructor(private formBuilder: FormBuilder){}

    ngOnInit(): void {
        this.form = new FormGroup({});

        this.form.addControl("pin1", new FormControl(this.pinInputs[0],[Validators.required]));
        this.form.addControl("pin2", new FormControl(this.pinInputs[1],[Validators.required]));
        this.form.addControl("pin3", new FormControl(this.pinInputs[2],[Validators.required]));
        this.form.addControl("pin4", new FormControl(this.pinInputs[3],[Validators.required]));
        this.form.addControl("pin5", new FormControl(this.pinInputs[4],[Validators.required]));

        this.emailForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email]]
        });

        // dismiss error when form is updated.
        this.form.valueChanges.subscribe((values: any) => {
            this.pin = values.pin1 + values.pin2 + values.pin3 + values.pin4 + values.pin5;
            this.isPinValid();
        });
    }

    ngOnDestroy(): void {
        this.clearForm();
    }

    onContinueStep() {
        if (this.isInputReady()){
            this.step = this.SIGANTURE_STEP_TWO;
        }
    }

    onStepBack(){
        this.step = this.SIGANTURE_STEP_ONE;
        this.clearForm()
    }

    onAction() {
        if (this.isInputReady() && this.isPinValid()){
            if(this.signatureType == this.SIGNATURE_TYPES_ENUM.CFR11_COMPLETE_EMAIL)
                this.mainAction.emit({email:this.input, pin: this.pin});
            else
                this.mainAction.emit({password:this.input, pin: this.pin});
            // this.clearForm();
        }
    }


    onSecondAction() {
        this.secondAction.emit(true);
    }

    isInputReady() : boolean {
        if(this.required && this.signatureType == this.SIGNATURE_TYPES_ENUM.CFR11_COMPLETE_EMAIL){
            this.validEmail = !this.emailForm.invalid;
            return this.validEmail;
        }
        if(this.required){
            return this.input != '';
        }
        return true;  
    }

    isPinValid() : boolean {
        this.validPin = this.pin.length === 5;
        if(this.pinRequestStatus != this.PIN_STATUS.DEFAULT){
            return this.pinRequestStatus == this.PIN_STATUS.RENEWED && this.validPin;
        } else {
            return this.validPin;
        }
    }

    protected clearForm() {
        this.form.reset();
    }

    requestNewPin() {
        this.pinRequested = true;
        this.pinRequestAction.emit();
        this.clearForm();
    }

}
